import { render, staticRenderFns } from "./ShadowsModule.vue?vue&type=template&id=66f60734&scoped=true"
import script from "./ShadowsModule.vue?vue&type=script&lang=js"
export * from "./ShadowsModule.vue?vue&type=script&lang=js"
import style0 from "./ShadowsModule.vue?vue&type=style&index=0&id=66f60734&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f60734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f60734')) {
      api.createRecord('66f60734', component.options)
    } else {
      api.reload('66f60734', component.options)
    }
    module.hot.accept("./ShadowsModule.vue?vue&type=template&id=66f60734&scoped=true", function () {
      api.rerender('66f60734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/ShadowsModule.vue"
export default component.exports